import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid'

interface StatusIconProps {
  value?: boolean | null
}

export default function StatusIcon({ value }: StatusIconProps) {
  if (value === true) {
    return <CheckCircleIcon className="w-5 h-5 text-green-600" />
  } else if (value === false) {
    return <XCircleIcon className="w-5 h-5 text-red-600" />
  }
  return <span className="text-gray-400">N/A</span>
}
